<script setup lang="ts">

const props = defineProps({
  ageGroup: {type: Number, default: 0}
})


const ageGroupInfo = computed(() => {
  const text = ageGroupList.find(g => g.value === props.ageGroup)?.label || 'Livre'
  switch (props.ageGroup) {
    case 18:
      return {bg: 'bg-dark-subtle', color: "bg-dark", text}
    case 16:
      return {bg: 'bg-danger-subtle', color: "bg-danger", text}
    case 14:
      return {bg: 'bg-warning-subtle', color: "bg-warning", text}
    case 12:
      return {bg: 'bg-primary-subtle', color: "bg-primary", text}
    case 10:
      return {bg: 'bg-info-subtle', color: "bg-info", text}
    case 6:
      return {bg: 'bg-6-subtle', color: "bg-6", text}
    default:
      return {bg: 'bg-success-subtle', color: "bg-success", text}
  }
})
</script>

<template>
  <div class="card rounded-3" :class="ageGroupInfo.bg" v-if="ageGroup > 0">
    <div class="card-body">
      <div class="icon-box">
        <div class="icon-box-media text-white me-2" :class="ageGroupInfo.color">
          {{ ageGroup }}
        </div>
        <h3 class="icon-box-title fs-base mt-1">Classificação etária</h3>
        <p class="fs-sm">Verifique se o espectador tem a idade recomendada. Em alguns casos, a entrada de menores da
          classificação não será permitida, mesmo quando acompanhados dos pais. Caso haja dúvida, consulte a produção do
          evento antes de comprar. O não cumprimento da classificação etária <b>não dá direito a reembolso</b>. Confirme
          todas as
          regras antecipadamente para garantir sua entrada e evitar prejuízos.</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.bg-dark-subtle {
  background: #000000a6 !important;
  color: white;
}
.bg-6-subtle{
  background: #ffb2d8 !important;
}
.bg-6{
  background: #d82d82 !important;
}
</style>
